import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaPrint } from "react-icons/fa";
import "../../Styles/yellowcalfcss/PaidBillView.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";

const PaidViewBill = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [bill, setBill] = useState(null);

  useEffect(() => {
    fetchPaidBill();
  }, [id]);

  const fetchPaidBill = async () => {
    setLoading(true);

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
      id: Number(id),
    };

    try {
      const response = await simplePostCall(
        ApiConfig.paidViewBill,
        JSON.stringify(requestBody)
      );

      if (response?.result) {
        setBill(response);
      }
    } catch (error) {
      console.error("Paid bill view error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !bill) {
    return <div className="paidbillview-container">Loading...</div>;
  }

  const customer = bill.customer?.[0];

  return (
    <>
      {/* HEADER */}
      <div className="expenses-view-bill-1-header-row">
        <h1 className="expenses-view-bill-1-page-title">View Paid Bill</h1>

        <div className="expenses-view-bill-1-header-actions">
          <button
            className="expenses-view-bill-1-btn expenses-view-bill-1-btn-print"
            onClick={() => window.print()}
          >
            Print <FaPrint style={{ marginLeft: "5px" }} />
          </button>
        </div>
      </div>


      <div className="paidbillview-container">

         <div className="paidbillview-customer-header text-center mb-4">
        {customer?.customer_address},{" "}
        {customer?.customer_city},{" "}
        {customer?.customer_country},{" "}
        {customer?.customer_mobile},{" "}
        {customer?.customer_email}
      </div>
        <h2 className="paidbillview-title">Receipt</h2>

        {/* TOP INFO BOX */}
        <div className="paidbillview-info-box">
          <div>
            <strong>Bill No:</strong> {bill.bill_number}
          </div>
          <div>
            <strong>Supplier:</strong> {bill.supplier_name}
          </div>
          <div>
            <strong>Paid Date:</strong> {bill.bill_payment_date}
          </div>
          <div>
            <strong>Transaction Id:</strong> {bill.transaction_id}
          </div>
        </div>

        {/* TABLE */}
        <table className="paidbillview-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Items</th>
              <th>Item Total</th>
            </tr>
          </thead>

          <tbody>
            {bill.bill_items?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.bill_item_name}</td>
                <td>{item.item_total}</td>
              </tr>
            ))}

            {/* SUMMARY ROWS */}
            <tr>
              <td></td>
              <td className="paidbillview-label">Grant Total</td>
              <td>{bill.bill_total_amount}</td>
            </tr>

            <tr>
              <td></td>
              <td className="paidbillview-label">Payment received</td>
              <td>{bill.bill_paid_amount}</td>
            </tr>

            <tr className="paidbillview-highlight">
              <td></td>
              <td className="paidbillview-label paidbillview-strong">
                Total Amount Paid
              </td>
              <td className="paidbillview-strong">
                {bill.bill_paid_amount}
              </td>
            </tr>

            <tr>
              <td></td>
              <td className="paidbillview-label">Due Amount</td>
              <td>{bill.bill_pending_amount}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PaidViewBill;
